const ACTIONS_BY_STATUS = {
  awaitingoffer: ["share"],
  accepted: ["changeAmount", "share"],
  confirmed: ["changeAmount", "share"],
  onthetrip: ["changeAmount", "share"],
  delivered: ["share"],
  return: ["share"],
  completed: ["share"],
};

export const getAviationExpeditorMenuActions = (status) =>
  ACTIONS_BY_STATUS[String(status || "").toLowerCase()] || [];
